import { useLoginInfo } from '@/components/LoginInfo/provider';

export const useCheckIsSupportedOffice = () => {
  const { currentOffice } = useLoginInfo();

  const isSupportedOffice = !!currentOffice && currentOffice.isMoreThanTeamPlan;

  return isSupportedOffice;
};
